import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';
import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';


// store findingsPromise to avoid multiple simultaneous API calls
let findingsPromise;
let findings = [];

export function search(resource, config = {filter: null}) {
    findingsPromise = API.search(resource, config)
        .catch(() => {
            return [];
        })
        .then(pFindings => {
            findings = pFindings;
            return findings;
        })
    ;
    return findingsPromise;
}

export async function searchByUser(config = {filter:{}}) {
    if(!config.filter.hasOwnProperty("user_id")) return;

    // otherwise fetch data from api then save the data in sessionstorage
    findingsPromise = API.search('v2/finding/', config)
        .catch(e => {
            return Promise.resolve([]);
        })
        .then(pFindings=> findings = pFindings)
    ;
    return findingsPromise;
}

export function find(resource, id, config = {}) {
    return API.find(resource, id, config);
}

export function save(data, files = [], config = {}) {
    let readLocale = getStore(locale);
    locale.set(readLocale);
    return API.upsert('v2/finding', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                let toastConfig = {
                    data: asset,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else{
                notificate('save_ok', "toast", {data: getStore(format)("finding.word")});
                return response.json();
            }
        })
    ;
}


export function saveProp(data, files = [], config = {}) {
    return API.upsert('v2/finding-property', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                let toastConfig = {
                    data: getStore(format)("notifications.element"),
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else{
                notificate('save_ok', "toast", {data: getStore(format)("notifications.element")});
                return response.json();
            }
        })
    ;
}


export function deleteProps(ids = [], config = {}) {
    return API.del('v2/finding-property', ids, config)
        .then(async (response) => {
            if (!response.ok) {
                let toastConfig = {
                    data: getStore(format)("finding.word"),
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            notificate('delete_ok', "toast", {data: "Propiedad"});
            return response.json();
        })
    ;
}


export function patch(data, files = [], config = {}) {
    return API.save('v2/finding', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                let toastConfig = {
                    data: asset,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else{
                if(!config.no_toaster) notificate('save_ok', "toast", {data: config && config.massive_addition ? getStore(format)("finding.plural") : getStore(format)("finding.word")});
                return response.json();
            }
        })
    ;
}

export function del(finding, config = {}) {
    return API.del('v2/finding', finding.id, config)
        .then(async (response) => {
            if (!response.ok) {
                let toastConfig = {
                    data: getStore(format)("finding.word"),
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            notificate('delete_ok', "toast", {data: getStore(format)("finding.word")});
            return response.json();
        })
    ;
}


export function getCVE(id, config = {}) {
    return API.find('cve', id, config);
}

export function getSRT(id, config = {}) {
    return API.find('srt', id, config);
}

export function getCWE(id, config = {}) {
    return API.find('cwe', id, config);
}


export const labels = {
    good     : 'Buena',
    info     : 'Info',
    none     : 'Ninguna',
    low      : 'Baja',
    medium   : 'Media',
    high     : 'Alta',
    critical : 'Crítica',
};

/**
 * Parse status
 * Return label
 * @param string status
 * @return string
 */
export function statusLabel(status) {
    const labels = {
        open     : 'Abierto',
        closed   : 'Cerrado',
    };

    return labels[status];
}

/**
 * Return severity totals
 *
 * @param [] findings
 * @return {}
 */
export function severityTotals(findings = []) {
    // easier to populate
    let totals = {
        critical : 0,
        high     : 0,
        medium   : 0,
        low      : 0,
    };

    findings.forEach(finding => {
        if (finding.vulnerability.priority > 0) {
            totals[finding.vulnerability.level]++;
        }
    });

    return totals;
}

export async function hydrateFindingWithAsset(finding){
    if(finding.asset_type == 'Domain'){
        return domainService.find(finding.domain_id).then(domain=>{
            finding.asset = domain;
            return finding;
        });
    }
    if(finding.asset_type == 'Cloud'){
        return cloudService.find(finding.cloud_resource_id.cloud_id).then(cloud=>{
            finding.asset = cloud;
            return finding;
        });
    }
    if(finding.asset_type == 'Service'){
        return serviceService.find(finding.service_id).then(srv=>{
            srv.name = srv.url ? srv.url : srv.ip_address + "/" + srv.protocol + "/" + srv.port;
            finding.asset = srv;
            return finding;
        });


    }
    if(finding.asset_type == 'Other'){
        return oAssetsApi.find(finding.asset_id).then(oAsset=>{
            finding.asset = oAsset;
            return finding;
        });
    }
}


/**
 * Return highest severity
 *
 * @param [] findings
 * @return {}
 */
 export function highestSeverity(findings = []) {
    /**
     *  @var []   : {name, label, total}
     */
    let max = 0;

    findings.forEach(finding => {
        if (finding.vulnerability.priority > max) {
            max = finding.vulnerability.priority;
        }
    });

    return max;
}

export default {
    search,
    searchByUser,
    find,
    save,
    saveProp,
    deleteProps,
    patch,
    del,
    getCVE,
    getCWE,
    labels,
    statusLabel,
    severityTotals,
    highestSeverity,
    hydrateFindingWithAsset
}
